import Principal from "../componentes/compartidos/Principal.js";
import Nav from "../componentes/compartidos/Nav.js";
import Pie from '../componentes/compartidos/Pie';
import { 
  Outlet,
 } from "react-router-dom";

export default function Root(){
    return(
    <>
    <div className="App">
      <Nav />
      <Principal />
      <Pie />
    </div>
    
    <div id="detail">
        <Outlet />
    </div>
    </>

    )
};
